module.exports = __webpack_public_path__ + "r-v3/img/ml_36_00.14946f77.jpg";